import _get from 'lodash/get';

import { preFilterTypeToAppSyncFilterTypeMap } from '../../constants';

/**
 * @param preFilterValues array of current filter values
 * @param preFilterConfigs array of filter configs
 * @returns a {@link TableBmatDetectionFilterInput} object based upon the current filter values
 */
export const mapPreFilterValuesToExportDetectionsFilter = (
    preFilterValues: PreFilterValue[],
    preFilterConfigs: Map<string, PreFilterConfig>,
): TableBmatDetectionFilterInput =>
    preFilterValues.reduce((acc, preFilterValue) => {
        const preFilterConfig = Array.from(preFilterConfigs.values()).find(
            ({ id }) => preFilterValue.id === id,
        );

        if (preFilterConfig) {
            const { filterType, filterValuePath } = preFilterConfig;

            const value = _get(preFilterValue, filterValuePath);
            const key = [...filterValuePath].pop();

            if (value && key) {
                const appSyncFilterType =
                    preFilterTypeToAppSyncFilterTypeMap[filterType];

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                acc[key] = {
                    [appSyncFilterType]: value,
                };
            }
        }

        return acc;
    }, {} as TableBmatDetectionFilterInput);
